/**
 * External dependencies
 */
import Immerable from '@naruto/naruto-reducers/src/types/GeneralImmer';

/**
 * Internal dependencies
 */
import { ServiceList, Services, ServiceListCondition, ServiceInfo, ServiceInfos } from './types';

class Service extends Immerable {
  public serviceListDefaultCondition: ServiceListCondition;

  public serviceList: Services;

  public serviceInfos: ServiceInfos;

  public constructor() {
    super();
    this.serviceListDefaultCondition = {
      api: {
        page: 1,
        page_size: 40,
        with_pager: false
      },
      display: {
        keyword: ''
      }
    };
    this.serviceList = {
      condition: this.serviceListDefaultCondition,
      content: {
        list: [],
        pager: {
          page: 0,
          page_size: 0,
          total_page: 0,
          total_count: 0
        }
      }
    };
    this.serviceInfos = {};
  }

  public initialize(): void {
    this.serviceListDefaultCondition = {
      api: {
        page: 1,
        page_size: 40,
        with_pager: false
      },
      display: {
        keyword: ''
      }
    };
    this.serviceList = {
      condition: this.serviceListDefaultCondition,
      content: {
        list: [],
        pager: {
          page: 0,
          page_size: 0,
          total_page: 0,
          total_count: 0
        }
      }
    };
    this.serviceInfos = {};
  }

  public updateServiceList(newList: ServiceList, newCondition: ServiceListCondition): void {
    this.serviceList = { content: newList, condition: newCondition };
  }

  public updateServiceInfo(newServiceID: string, newService: ServiceInfo): void {
    this.serviceInfos[newServiceID] = newService;
  }
}

export default Service;
